import { ExceptionEvent, Geotab } from "@fairfleet/geotab";
import { useMutation, useQueryClient } from "@tanstack/react-query";

async function updateExceptionEvent(props: { entity: ExceptionEvent; geotabClient: Geotab }) {
  const { entity, geotabClient } = props;
  const result = await geotabClient.call("Set", {
    typeName: "ExceptionEvent",
    entity,
  });
  return result;
}

export function useUpdateExceptionEvent(invalidate?: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateExceptionEvent,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [invalidate ?? "DeviceStatusInfo"],
      });
    },
  });
}
